import { DEFAULT_MAPS_SELECTED, DEFAULT_WINGMAN_MAPS_SELECTED } from "../../constants/maps";

export default {
  catalog: {
    account: {},
    accountUpdateDuring: false,
    accountUpdateComplete: null,
    accountUpdateAlert: false,
    avatarCacheBust: 0,
    matchAcceptDialogState: false,
    mapVoteState: false,
    accountUpdateAlertText: "",
    requestDevice: {
      isAndroidOrIosPhone: false,
    },
    publicTemplate: {
      codename: "original",
      isResolved: false,
    },
    matchmakingOptions: {},
    lobbyState: "standby",
    lobbyMapsSelected: DEFAULT_MAPS_SELECTED, // All maps by default
    lobbyWingmanMapsSelected: DEFAULT_WINGMAN_MAPS_SELECTED,
    user: null,
    profileData: null,
    profileDataLoading: false,
    matchSummary: null,
    mapsStats: null,
    last25MatchData: null,
    activityMatches: [],
    sortOptions: {
      general: "date",
      map: "all maps",
    },
    performLogout: false,
    snackbar: null,
    toggleSnackbar: false,
    matchFound: false,
    matchPageMissingId: null,
    matchData: false,
    scoreboardData: false,
    matchAnalysis: null,
    usersMetaData: false,
    inviteData: null,
    inviteCountdown: 60000,
    inviteDialogOpen: false,
    inviteError: null,
    inviteSlotAssignments: {},
    profileRelationship: 'none',
    friendSidebarOpen: false,
    lobbySettingsMenuOpen: false,
    friendSidebarActiveTab: 'friendlist',
    friendSearchResults: [],
    playerSearch: {
      loading: false,
      total: 0,
      offset: 0,
      error: null,
    },
    globalPlayerSearchResults: [],
    globalPlayerSearch: {
      loading: false,
      error: null,
      requestId: null,
    },
    currentLobby: null,
    currentLobbyCode: null,
    playerJoinedNotification: {
      visible: false,
      nickname: null,
      type: null,
    },
    confirmDialog: {
      open: false,
      which: null, 
    },
    showUnavailableActionMessage: false,
    queueErrorMessage: null,
    queueBlockedModal: {
      open: false,
      reason: null,
      message: null,
      blockedMembers: [],
    },
    queueStatus: null,
    expandedSearch: false,
    matchmakingStarted: false,
    reportPlayer: {
      offenses: {},
      remarks: "",
    },
    leaderboard: {
      loading: false,
      error: null,
      scope: "global",
      region: "Europe",
      country: null,
      rows: [],
      total: 0,
      offset: 0,
      limit: 50,
      aggregates: null,
    },
    latestMatches: {
      status: "idle",
      matches: [],
      serverTimeMs: null,
      error: null,
    },
    membership: {
      tier: "free",
      billingCycle: null,
      subscriptionId: null,
      subscriptionStatus: null,
      cancelledAt: null,
      yearlyRenewalEligible: false,
      expiresAt: null,
      daysRemaining: null,
      grantedByAdmin: false,
      limits: null,
    },
    selectedServerLocations: [],
    serverLocations: [],
    csSkills: null,
    csSkillsTemplate: null,
    platformStats: {
      serversOnline: null,
      playersSearching: null,
      activeMatches: null,
    },
  },
};
